import {
    GOOGLEMAPS_API_KEY,
    NAME_TO_SLUG_UPDATE,
    DATE_TIME_SEQUENCER_UPDATE,
    DATE_TIME_SEQUENCER_ENABLE
} from '../config';
import {_} from 'underscore';

$(function () {
    window.watchInputs = (function () {
        let elmId = '.admin-panel--header.danger-color',
            mainElm = $(elmId),
            triggerDataAttribute = 'admin-panel-input--trigger';

        function update(elm) {
            let defaultColor = elm.data('admin-panel-input--default-color'),
                dangerColor = elm.data('admin-panel-input--danger-color');

            if (elm.hasClass(dangerColor)) {
                elm.removeClass(dangerColor);
                elm.addClass(defaultColor);
            }
        }

        function getTrigger(elm) {
            return elm.data(triggerDataAttribute);
        }

        function setup() {
            mainElm.each(function () {
                let parent = $(this);

                $(getTrigger(parent)).on('change', function () {
                    update(parent);
                })
            })

        }

        return {
            init: function () {
                if (mainElm.length > 0) {
                    setup();
                }
            },
            changed: function (elm) {
                let parent = elm.closest('.admin-panel').find(elmId);
                console.log('elm', elm, 'parent', parent);

                update(parent)
            }
        }
    })();
    window.watchInputs.init();
});
//Making sure with a single ticket, the admin can only select one event
$(function () {
    /**
     *
     * @param {String} item
     */
    function isSingleOrAddon(item) {
        if (item === 'single') {
            return true
        } else if (item === 'addon') {
            return true
        }
        return false;
    }

    $('#price-field')
        .change(function () {
            this.value = parseFloat(this.value).toFixed(2);

            $(this).removeClass('invalid').parent().find('i').removeClass('error');

            if (parseInt($(this).val().replace('.', '')) > parseInt($(this).data('max_value'))
                || parseInt($(this).val().replace('.', '')) < parseInt($(this).data('min_value'))) {
                $(this).addClass('invalid').parent().find('i').addClass('error');
            }
        })
        .keydown(function (key) {
            if (key.key === "e" || key.key === "E") {
                key.preventDefault();
            }
        });

    let dateTime = null,
        date_time = null;

    if ($('#date_time_sequencer--wrapper').length > 0) {
        dateTime = Vue.extend({
//				props: ['content']
        });
        let ticketsCrudData = function(){
            return {}
        };
if(typeof window.tickets_crud !== 'undefined' && window.tickets_crud !== null){
    ticketsCrudData =  window.tickets_crud.data;
}

        date_time = new dateTime({
            el: '#date_time_sequencer--wrapper',
            data: ticketsCrudData
        });
    }


    let ticket_type_select = $('#ticket_type--select');

    if (ticket_type_select.val() === 'addon') {
        /**
         * @function vueEventHub.$emit
         * @param vueEventHub
         */
        vueEventHub.$emit(DATE_TIME_SEQUENCER_ENABLE, false);
    }
    else if (ticket_type_select.val() === 'season') {

    }
    ticket_type_select
        .change(function () {
            // test for addon
            let value = $(this).val();
            // console.log(date_time)
            if (value === 'addon') {
                vueEventHub.$emit(DATE_TIME_SEQUENCER_ENABLE, false);
            } else {
                vueEventHub.$emit(DATE_TIME_SEQUENCER_ENABLE, true);
            }
        });


    let articles = [],
        searchString = '',
        ticketTypeClick;

    if (ticket_type_select.length <= 0) {
        return;
    }

    function readSelectCount() {
        return $(`.multi-select-advanced__item > input:checked`).length;
    }

    /**
     *
     * @param isError
     */
    function createTicketTypeError(isError) {
        if (isError) {
            ticket_type_select.addClass('invalid');

        } else {
            ticket_type_select.removeClass('invalid');
        }
    }

    /**
     *
     * @param elm
     * @param insert
     */
    function updateSelectedTag(elm, insert) {
        let id = elm.attr('id');

        if (insert) {

            let name = $(`[for="${id}"]`).text().trim();

            createTag(id, name);
        } else {
            deleteTag(id);
        }
    }

    /**
     *
     * @param id
     * @param name
     */
    function createTag(id, name) {
        if ($(`[data-selected_item_id="${id}"]`).length > 0) {
            return;
        }

        let template = `
<li class="chip purple lighten-2 white-text"
style="display:inline-block"
data-selected_item_id="${id}">
${name}<i class="close fa fa-times"></i></li>`,
            tag = $(template);

        $('.multi-select-advanced__selected-items').append(tag);
        watchTags();
    }

    /**
     *
     */
    function watchTags() {
        $('.multi-select-advanced__selected-items').find('li').unbind('click').click(function () {
            let id = $(this).attr('data-selected_item_id');

            deleteTag(id);
        })
    }

    /**
     *
     * @param inputId
     */
    function deleteTag(inputId) {
        // uncheck the input elm
        $('#' + inputId).prop('checked', false);

        //remove the preview elm
        $(`[data-selected_item_id="${inputId}"]`).remove();
    }

    /**
     *
     */
    function highlightTicketTypeSelector() {
        let elm = ticket_type_select.parent().find('input'),
            parentElm = elm.parent();
        // console.log('elm', elm);
        if (elm.hasClass('invalid')) {
            elm.removeClass('invalid');
            ticketTypeClick.unbind('click');
        } else {
            elm.addClass('invalid');

            parentElm.addClass('animated bounce')
                .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
                    $(this).removeClass('animated bounce');
                });

            ticketTypeClick = ticket_type_select
                .change(function () {
                    highlightTicketTypeSelector();
                });
        }

    }

    buildArticles();
    watchEventSearch();
    let multiSelectAdvancedItem = $(`.multi-select-advanced__item`);

    // allow event selection if a ticket type is selected
    if (ticket_type_select.val() !== '') {
// console.log(' there is a value set for the ticket type', ticketTypeSelect.val());
        multiSelectAdvancedItem.find('input[type="checkbox"]').attr('disabled', false);
        // console.log('multiSelectAdvancedItem',multiSelectAdvancedItem);
        //
    }
    if (ticket_type_select.length <= 0) {
        console.error('ticketTypeSelect element cannot be found');
        return;
    }
    /**
     * Clicks on multiCheckbox. If the input is disabled and if the element is not checked then will not allow selection
     */
    multiSelectAdvancedItem.click(function () {
        // console.log('multiSelectAdvancedItem', $(`.multi-select-advanced__item`));
        let input = $(this).find('input'),
            isDisabled = input.attr('disabled');

        // console.log('input', input, 'isDisabled', isDisabled);

        let isSelected = input.attr('checked'),
            // isDisabledCheck = (typeof isDisabled !== typeof undefined && isDisabled !== false)?true:false ;
            isDisabledCheck = (typeof isDisabled !== typeof undefined && isDisabled !== false);

        // console.log('isSelected', isSelected, 'isDisabledCheck', isDisabledCheck);


        if (isDisabledCheck && isSelected !== 'checked') {
            toastr['error']('Ticket Type is required');
            console.warn('Cannot select because: input is disabled=' + isDisabledCheck, 'And/or element is not checked: ' + isSelected);
            highlightTicketTypeSelector();
            ticketTypeSelect.focus();
        }
    });

    /**
     *
     */
    function buildArticles() {
        $('.multi-select-advanced__item').find('label').each(function () {
            let text = $(this).text().trim();
            articles.push({
                title: $(this).text().trim(),
                id: $(this).attr('for')
            })
        });
    }

    /**
     *
     */
    function watchEventSearch() {
        $('#multi-select-advanced__search').keyup(function () {
            let articles_array = eventSearch($(this).val());
//					console.log('articles_array',articles_array);
            $('.multi-select-advanced__item').css({display: 'none'});
            $.each(articles_array, function (index, item) {
                $('#' + item.id).closest('.multi-select-advanced__item').css({display: 'block'});
            });
        });
    }

    /**
     *
     * @param val
     * @returns {Array}
     */
    function eventSearch(val) {
        let articles_array = articles,
            searchString = val;

        if (!searchString) {
            return articles_array;
        }

        searchString = searchString.trim().toLowerCase();

        articles_array = articles_array.filter(function (item) {
            if (item.title.toLowerCase().indexOf(searchString) !== -1) {
                return item;
            }
        });

        // Return an array with the filtered data.
        return articles_array;
    }

    function loadMaterialSelectTicketGroups() {

    }

    /**
     * Ticket type was selected. if it is a single then reset the event selection
     */
    ticket_type_select.change(function () {
        let ticketGroupWarning = $('#ticket-group-warning');
        if ($(this).hasClass('disabled')) {
            console.log('returning');
            return;
        }
        let ticketTypeValue = $(this).val(),
            inputs = $(`.multi-select-advanced__item > input`);

        inputs.removeAttr('disabled');
        // ticket_group_select.$emit('group_type',ticketTypeValue);

// console.log('ticket_group_select.$refs',ticket_group_select.$refs);
        // set the date time to active
        if (isSingleOrAddon(ticketTypeValue)) {

            if (readSelectCount() > 1) {
                inputs
                    .prop('checked', false)
                    .parent().removeClass('event-selected');
            }
            ticketGroupWarning.addClass('d-none');
            activateSeasonTicketGlobalSave(false);
        } else {
            // not single ticket
            // date_time.enable_app = false;
            ticketGroupWarning.removeClass('d-none');
            activateSeasonTicketGlobalSave(true);
            if (typeof ticket_group_select !== 'undefined' && ticket_group_select !== null) {
                ticket_group_select.$children[0].tags_chooser.params.group_type = ticketTypeValue;
            }
        }
    });

    /**
     * An event was selected
     */
    multiSelectAdvancedItem.change(function (e) {
        let type = ticket_type_select.val();

        if (readSelectCount() > 1 && ticket_type_select.val() === 'single') {
            $(e.target).prop('checked', false);
            toastr['error']('You have selected a single ticket. only one event can be assigned');
            createTicketTypeError(true);
            return false;
        } else {
            createTicketTypeError(false);
        }

        let state = true;

        if ($(e.target).prop('checked')) {
            $(e.target).parent().addClass('event-selected');
        } else {
            $(e.target).parent().removeClass('event-selected');
            state = false;
        }
        updateSelectedTag($(this).find('input'), state);
    });

    /**
     * Watch the entity selector
     */
    function watchEntitySelection() {
        // console.log('watching', $('#entity--select'));
        $('#entity--select').change(function () {
            //get the name
            let optionElement = $(this).find('option:selected'),
                entityName = optionElement.text(),
                openTime = optionElement.attr('data-open_time') || null,
                closeTime = optionElement.attr('data-close_time') || null
            ;
            // console.log('DATE_TIME_SEQUENCER_UPDATE', DATE_TIME_SEQUENCER_UPDATE);
            vueEventHub.$emit(DATE_TIME_SEQUENCER_UPDATE, {
                open_time: openTime,
                close_time: closeTime
            });
            vueEventHub.$emit(NAME_TO_SLUG_UPDATE, {
                text: entityName
            });
        });

    }

    watchEntitySelection();

    function activateSeasonTicketGlobalSave(activate) {
        if (typeof date_time.effect_global !== 'undefined' && date_time.effect_global !== null) {
            date_time.effect_global.active = activate;
            date_time.effect_global.show_global_switch = activate;
        }
        if (typeof ticket_group_select !== 'undefined' && ticket_group_select !== null) {

            ticket_group_select.$children[0].show_selection = activate;
        }

    }

    let selectedType = ticket_type_select.val();
    // console.log('selectedType', selectedType)
    if ((selectedType !== 'single' && selectedType !== 'addon') && selectedType !== '') {
        if (typeof date_time !== 'undefined' && date_time !== null) {
            date_time.effect_global.active = true;
            date_time.effect_global.show_global_switch = true;
        }
        // is a vue instance on the blade template
        if (typeof ticket_group_select !== 'undefined' && ticket_group_select !== null) {
            ticket_group_select.$children[0].show_selection = true;
            if(typeof ticket_group_select.$children[0].tags_chooser.params !== 'undefined'){
                ticket_group_select.$children[0].tags_chooser.params.group_type = selectedType;
            }
        }


    } else {
        if (typeof ticket_group_select !== 'undefined' && ticket_group_select !== null) {
            ticket_group_select.$children[0].show_selection = false;

        }
        if (typeof date_time.effect_global !== 'undefined' && date_time.effect_global !== null) {
            date_time.global_switch_model = true;
            date_time.effect_global.active = true;
            date_time.effect_global.show_global_switch = true;
            date_time.effect_global.show_app = true;
        }
    }
});

$(function () {


});




// WEBPACK FOOTER //
// ./resources/assets/js/pages/tickets--crud.js